import { useSelector } from '@xstate/react';

import { useGlobalAppState } from '../../../../context/GlobalAppState';
import { useBagIds } from '../../../../hooks';
import { getValidEventKeys } from '../utils';

import type { ReorderStep } from '../../machines/Reorder.machine';

export const useReorderState = () => {
  const { reorderMachineRef } = useGlobalAppState();
  const state = useSelector(reorderMachineRef, (snapshot) => snapshot);
  const { bagRestaurantSlug, bagAddressId } = useBagIds();

  return {
    ...getValidEventKeys(state.context),
    currentStep: state.value as ReorderStep,
    previousStep: state.context.previousStep,
    previousEvent: state.context,
    hasBag: Boolean(bagRestaurantSlug) || Boolean(bagAddressId),
  };
};
